<template>
    <div>
        <form class="form-horizontal">
            <h5 class="section-divider">
                {{ $t("employee.employment") }}
            </h5>
            <div class="row">
                <div class="col-md-6">
                    <div class="row mb-3">
                        <label class="col-md-4">
                            {{ $t("employee.salaryLevel") }}
                        </label>
                        <div class="col-md-8">
                            <div
                                class="tw-flex tw-items-center tw-justify-between"
                            >
                                <div class="tw-justify-start">
                                    <select
                                        v-model.number="model.level_id"
                                        class="form-select"
                                        :class="{
                                            'is-invalid': errors.has('level_id')
                                        }"
                                        @change="
                                            () => (model.salary_level_id = null)
                                        "
                                    >
                                        <option :value="null">{{
                                            $t("select")
                                        }}</option>
                                        <option
                                            v-for="(value, index) in levels"
                                            :key="index"
                                            :value="value.id"
                                        >
                                            {{ value.name }}
                                        </option>
                                    </select>
                                    <div
                                        class="invalid-feedback"
                                        v-if="errors.has('level_id')"
                                    >
                                        {{ errors.first("level_id") }}
                                    </div>
                                </div>
                                <div class="tw-justify-end">
                                    <select
                                        v-model.number="model.salary_level_id"
                                        class="form-select"
                                        :class="{
                                            'is-invalid': errors.has(
                                                'salary_level_id'
                                            )
                                        }"
                                    >
                                        <option :value="null">{{
                                            $t("select")
                                        }}</option>
                                        <option
                                            v-for="(value,
                                            index) in salaryLevels"
                                            :key="index"
                                            :value="value.id"
                                        >
                                            {{ value.name }}
                                        </option>
                                    </select>
                                    <div
                                        class="invalid-feedback"
                                        v-if="errors.has('salary_level_id')"
                                    >
                                        {{ errors.first("salary_level_id") }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-md-4">
                            {{ $t("employee.age") }}
                        </label>
                        <div class="col-md-8">
                            <input
                                v-model.number="model.age"
                                type="number"
                                class="form-control"
                                :class="{
                                    'is-invalid': errors.has('age')
                                }"
                            />
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-md-4">
                            {{ $t("employee.marritalStatus") }}
                        </label>
                        <div class="col-md-8">
                            <select
                                v-model.number="model.marrital_status"
                                class="form-select"
                                :class="{
                                    'is-invalid': errors.has('marrital_status')
                                }"
                            >
                                <option :value="null">{{
                                    $t("select")
                                }}</option>
                                <option
                                    v-for="(value, index) in marritalStatus"
                                    :key="index"
                                    :value="value"
                                >
                                    {{ value }}
                                </option>
                            </select>
                            <div
                                class="invalid-feedback"
                                v-if="errors.has('marrital_status')"
                            >
                                {{ errors.first("marrital_status") }}
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-md-4 required">
                            {{ $t("employee.employerName") }}
                        </label>
                        <div class="col-md-8">
                            <input
                                v-model.trim="model.employer_name"
                                type="text"
                                class="form-control"
                                :class="{
                                    'is-invalid': errors.has('employer_name')
                                }"
                            />
                            <div
                                class="invalid-feedback"
                                v-if="errors.has('employer_name')"
                            >
                                {{ errors.first("employer_name") }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row mb-3">
                        <label class="col-md-4">
                            {{ $t("employee.province") }}
                        </label>
                        <div class="col-md-8">
                            <select
                                v-model="model.province_code"
                                class="form-control"
                                :class="{
                                    'is-invalid': errors.has('province_code')
                                }"
                                @change="provinceChange(model.province_code)"
                                @input="
                                    model.district_code = model.commune_code = model.village_code = null
                                "
                            >
                                <option
                                    :value="null"
                                    disabled
                                    selected
                                    style="display: none;"
                                    >{{ $t("select") }}</option
                                >
                                <option
                                    v-for="(province, index) in provinces"
                                    :key="index"
                                    :value="province.province_code"
                                >
                                    {{ province.name_en }} |
                                    {{ province.name_kh }}
                                </option>
                            </select>
                            <div
                                class="invalid-feedback"
                                v-if="errors.has('province_code')"
                            >
                                {{ errors.first("province_code") }}
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-md-4">
                            {{ $t("employee.district") }}
                        </label>
                        <div class="col-md-8">
                            <ts-loading-banner :loading="province_change">
                                <select
                                    v-model="model.district_code"
                                    class="form-control"
                                    :class="{
                                        'is-invalid': errors.has(
                                            'district_code'
                                        )
                                    }"
                                    @change="
                                        districtChange(model.district_code)
                                    "
                                    @input="
                                        model.commune_code = model.village_code = null
                                    "
                                >
                                    <option
                                        :value="null"
                                        disabled
                                        selected
                                        style="display: none;"
                                        >{{ $t("select") }}</option
                                    >
                                    <option
                                        v-for="(district, index) in districts"
                                        :key="index"
                                        :value="district.district_code"
                                    >
                                        {{ district.name_en }} |
                                        {{ district.name_kh }}
                                    </option>
                                </select>
                            </ts-loading-banner>
                            <div
                                class="invalid-feedback"
                                v-if="errors.has('district_code')"
                            >
                                {{ errors.first("district_code") }}
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-md-4">
                            {{ $t("employee.commune") }}
                        </label>
                        <div class="col-md-8">
                            <ts-loading-banner :loading="district_change">
                                <select
                                    v-model="model.commune_code"
                                    class="form-control"
                                    :class="{
                                        'is-invalid': errors.has('commune_code')
                                    }"
                                    @change="communeChange(model.commune_code)"
                                    @input="model.village_code = null"
                                >
                                    <option
                                        :value="null"
                                        disabled
                                        selected
                                        style="display: none;"
                                        >{{ $t("select") }}</option
                                    >
                                    <option
                                        v-for="(commune, index) in communes"
                                        :key="index"
                                        :value="commune.commune_code"
                                    >
                                        {{ commune.name_en }} |
                                        {{ commune.name_kh }}
                                    </option>
                                </select>
                            </ts-loading-banner>
                            <div
                                class="invalid-feedback"
                                v-if="errors.has('commune_code')"
                            >
                                {{ errors.first("commune_code") }}
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-md-4">
                            {{ $t("employee.village") }}
                        </label>
                        <div class="col-md-8">
                            <ts-loading-banner :loading="commune_change">
                                <div class="input-group">
                                    <select
                                        v-model="model.village_code"
                                        class="form-control"
                                        :class="{
                                            'is-invalid': errors.has(
                                                'village_code'
                                            )
                                        }"
                                    >
                                        <option
                                            :value="null"
                                            disabled
                                            selected
                                            style="display: none;"
                                            >{{ $t("select") }}</option
                                        >
                                        <option
                                            v-for="(village, index) in villages"
                                            :key="index"
                                            :value="village.village_code"
                                        >
                                            {{ village.name_en }} |
                                            {{ village.name_kh }}
                                        </option>
                                    </select>
                                    <Poptip
                                        :title="$t('employee.village')"
                                        :transfer="true"
                                        width="240"
                                        @on-popper-show="
                                            () => (name_en = name_kh = '')
                                        "
                                        v-if="
                                            !villageSaving && model.commune_code
                                        "
                                    >
                                        <a
                                            class="btn btn-info"
                                            v-tooltip="$t('add')"
                                            :disabled="villageSaving"
                                        >
                                            <i
                                                class="fas fa-circle-notch fa-spin"
                                                v-if="villageSaving"
                                            ></i>
                                            <i class="fas fa-plus" v-else></i>
                                        </a>
                                        <div slot="content">
                                            <div class="mb-2">
                                                <label class="required">{{
                                                    $t("employee.nameEn")
                                                }}</label>
                                                <input
                                                    v-model.trim="name_en"
                                                    type="text"
                                                    class="form-control"
                                                    :class="{
                                                        'is-invalid': errors.has(
                                                            'name_en'
                                                        )
                                                    }"
                                                />
                                                <div
                                                    class="invalid-feedback"
                                                    v-if="errors.has('name_en')"
                                                >
                                                    {{
                                                        errors.first("name_en")
                                                    }}
                                                </div>
                                            </div>
                                            <div class="mb-2">
                                                <label class="required">{{
                                                    $t("employee.nameKh")
                                                }}</label>
                                                <input
                                                    v-model.trim="name_kh"
                                                    type="text"
                                                    class="form-control"
                                                    :class="{
                                                        'is-invalid': errors.has(
                                                            'name_kh'
                                                        )
                                                    }"
                                                />
                                                <div
                                                    class="invalid-feedback"
                                                    v-if="errors.has('name_kh')"
                                                >
                                                    {{
                                                        errors.first("name_kh")
                                                    }}
                                                </div>
                                            </div>
                                            <div class="tw-mt-2 tw-text-right">
                                                <a
                                                    class="ivu-btn ivu-btn-primary ivu-btn-small"
                                                    @click.prevent="
                                                        onSaveVillage
                                                    "
                                                >
                                                    <span>Save</span>
                                                </a>
                                            </div>
                                        </div>
                                    </Poptip>
                                    <a
                                        class="btn btn-default"
                                        v-tooltip="$t('add')"
                                        :disabled="!model.commune_code"
                                        v-else
                                    >
                                        <i
                                            class="fas fa-circle-notch fa-spin"
                                            v-if="villageSaving"
                                        ></i>
                                        <i class="fas fa-plus" v-else></i>
                                    </a>
                                </div>
                            </ts-loading-banner>
                            <div
                                class="invalid-feedback"
                                v-if="errors.has('village_code')"
                            >
                                {{ errors.first("village_code") }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <h5 class="section-divider">
                {{ $t("employee.employeeGuarantor") }}
            </h5>
            <div class="row">
                <div class="col-md-6">
                    <div class="row mb-3">
                        <label class="col-md-4 required">
                            {{ $t("employee.guarantorName") }}
                        </label>
                        <div class="col-md-8">
                            <input
                                v-model.trim="model.guarantor_name"
                                type="text"
                                class="form-control"
                                :class="{
                                    'is-invalid': errors.has('guarantor_name')
                                }"
                            />
                            <div
                                class="invalid-feedback"
                                v-if="errors.has('guarantor_name')"
                            >
                                {{ errors.first("guarantor_name") }}
                            </div>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <label class="col-md-4">
                            {{ $t("employee.sex") }}
                        </label>
                        <div class="col-md-8">
                            <div class="tw-flex">
                                <div class="tw-justify-start">
                                    <div class="form-check form-check-inline">
                                        <input
                                            class="form-check-input"
                                            type="radio"
                                            id="male"
                                            v-model="model.guarantor_sex"
                                            value="Male"
                                        />
                                        <label
                                            class="form-check-label"
                                            for="male"
                                            >Male</label
                                        >
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input
                                            class="form-check-input"
                                            type="radio"
                                            id="female"
                                            v-model="model.guarantor_sex"
                                            value="Female"
                                        />
                                        <label
                                            class="form-check-label"
                                            for="female"
                                            >Female</label
                                        >
                                    </div>
                                </div>
                                <div class="tw-justify-end">
                                    <input
                                        v-model.trim="model.guarantor_age"
                                        :placeholder="
                                            $t('employee.guarantorAge')
                                        "
                                        type="number"
                                        class="form-control"
                                        :class="{
                                            'is-invalid': errors.has(
                                                'guarantor_age'
                                            )
                                        }"
                                    />
                                </div>
                            </div>
                            <div
                                class="text-danger"
                                v-if="errors.has('guarantor_sex')"
                            >
                                {{ errors.first("guarantor_sex") }}
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-md-4">
                            {{ $t("employee.ssnNo") }}
                        </label>
                        <div class="col-md-8">
                            <input
                                v-model.trim="model.guarantor_nid_number"
                                type="text"
                                class="form-control"
                                :class="{
                                    'is-invalid': errors.has(
                                        'guarantor_nid_number'
                                    )
                                }"
                            />
                            <div
                                class="invalid-feedback"
                                v-if="errors.has('guarantor_nid_number')"
                            >
                                {{ errors.first("guarantor_nid_number") }}
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-md-4">
                            {{ $t("employee.nationality") }}
                        </label>
                        <div class="col-md-8">
                            <select
                                v-model.number="model.nationality_id"
                                class="form-control"
                                :class="{
                                    'is-invalid': errors.has('nationality_id')
                                }"
                            >
                                <option :value="null">{{
                                    $t("select")
                                }}</option>
                                <option
                                    v-for="(nationality,
                                    index) in nationalities"
                                    :key="index"
                                    :value="nationality.nationality_id"
                                    >{{
                                        nationality.nationality_name_en
                                    }}</option
                                >
                            </select>
                            <div
                                class="invalid-feedback"
                                v-if="errors.has('nationality_id')"
                            >
                                {{ errors.first("nationality_id") }}
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-md-4">
                            {{ $t("employee.spouseName") }}
                        </label>
                        <div class="col-md-8">
                            <input
                                v-model.trim="model.spouse_name"
                                type="text"
                                class="form-control"
                                :class="{
                                    'is-invalid': errors.has('spouse_name')
                                }"
                            />
                            <div
                                class="invalid-feedback"
                                v-if="errors.has('spouse_name')"
                            >
                                {{ errors.first("spouse_name") }}
                            </div>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <label class="col-md-4">
                            {{ $t("employee.sex") }}
                        </label>
                        <div class="col-md-8">
                            <div class="tw-flex">
                                <div class="tw-justify-start">
                                    <div class="form-check form-check-inline">
                                        <input
                                            class="form-check-input"
                                            type="radio"
                                            id="spouse_male"
                                            v-model="model.spouse_sex"
                                            value="Male"
                                        />
                                        <label
                                            class="form-check-label"
                                            for="spouse_male"
                                            >Male</label
                                        >
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input
                                            class="form-check-input"
                                            type="radio"
                                            id="spouse_female"
                                            v-model="model.spouse_sex"
                                            value="Female"
                                        />
                                        <label
                                            class="form-check-label"
                                            for="spouse_female"
                                            >Female</label
                                        >
                                    </div>
                                </div>
                                <div class="tw-justify-end">
                                    <input
                                        v-model.trim="model.spouse_age"
                                        :placeholder="$t('employee.spouseAge')"
                                        type="number"
                                        class="form-control"
                                        :class="{
                                            'is-invalid': errors.has(
                                                'spouse_age'
                                            )
                                        }"
                                    />
                                </div>
                            </div>
                            <div
                                class="text-danger"
                                v-if="errors.has('spouse_sex')"
                            >
                                {{ errors.first("spouse_sex") }}
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-md-4">
                            {{ $t("employee.ssnNo") }}
                        </label>
                        <div class="col-md-8">
                            <input
                                v-model.trim="model.spouse_nid_number"
                                type="text"
                                class="form-control"
                                :class="{
                                    'is-invalid': errors.has(
                                        'spouse_nid_number'
                                    )
                                }"
                            />
                            <div
                                class="invalid-feedback"
                                v-if="errors.has('spouse_nid_number')"
                            >
                                {{ errors.first("spouse_nid_number") }}
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-md-4">
                            {{ $t("employee.relationship") }}
                        </label>
                        <div class="col-md-8">
                            <input
                                v-model.trim="model.relationship"
                                type="text"
                                class="form-control"
                                :class="{
                                    'is-invalid': errors.has('relationship')
                                }"
                            />
                            <div
                                class="invalid-feedback"
                                v-if="errors.has('relationship')"
                            >
                                {{ errors.first("relationship") }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row mb-3">
                        <label class="col-md-4">
                            {{ $t("employee.province") }}
                        </label>
                        <div class="col-md-8">
                            <select
                                v-model="model.grt_province_code"
                                class="form-control"
                                :class="{
                                    'is-invalid': errors.has(
                                        'grt_province_code'
                                    )
                                }"
                                @change="
                                    grtProvinceChange(model.grt_province_code)
                                "
                                @input="
                                    model.grt_district_code = model.grt_commune_code = model.grt_village_code = null
                                "
                            >
                                <option
                                    :value="null"
                                    disabled
                                    selected
                                    style="display: none;"
                                    >{{ $t("select") }}</option
                                >
                                <option
                                    v-for="(province, index) in provinces"
                                    :key="index"
                                    :value="province.province_code"
                                >
                                    {{ province.name_en }} |
                                    {{ province.name_kh }}
                                </option>
                            </select>
                            <div
                                class="invalid-feedback"
                                v-if="errors.has('grt_province_code')"
                            >
                                {{ errors.first("grt_province_code") }}
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-md-4">
                            {{ $t("employee.district") }}
                        </label>
                        <div class="col-md-8">
                            <ts-loading-banner :loading="grt_province_change">
                                <select
                                    v-model="model.grt_district_code"
                                    class="form-control"
                                    :class="{
                                        'is-invalid': errors.has(
                                            'grt_district_code'
                                        )
                                    }"
                                    @change="
                                        grtDistrictChange(
                                            model.grt_district_code
                                        )
                                    "
                                    @input="
                                        model.grt_commune_code = model.grt_village_code = null
                                    "
                                >
                                    <option
                                        :value="null"
                                        disabled
                                        selected
                                        style="display: none;"
                                        >{{ $t("select") }}</option
                                    >
                                    <option
                                        v-for="(district,
                                        index) in grt_districts"
                                        :key="index"
                                        :value="district.district_code"
                                    >
                                        {{ district.name_en }} |
                                        {{ district.name_kh }}
                                    </option>
                                </select>
                            </ts-loading-banner>
                            <div
                                class="invalid-feedback"
                                v-if="errors.has('grt_district_code')"
                            >
                                {{ errors.first("grt_district_code") }}
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-md-4">
                            {{ $t("employee.commune") }}
                        </label>
                        <div class="col-md-8">
                            <ts-loading-banner :loading="grt_district_change">
                                <select
                                    v-model="model.grt_commune_code"
                                    class="form-control"
                                    :class="{
                                        'is-invalid': errors.has(
                                            'grt_commune_code'
                                        )
                                    }"
                                    @change="
                                        grtCommuneChange(model.grt_commune_code)
                                    "
                                    @input="model.grt_village_code = null"
                                >
                                    <option
                                        :value="null"
                                        disabled
                                        selected
                                        style="display: none;"
                                        >{{ $t("select") }}</option
                                    >
                                    <option
                                        v-for="(commune, index) in grt_communes"
                                        :key="index"
                                        :value="commune.commune_code"
                                    >
                                        {{ commune.name_en }} |
                                        {{ commune.name_kh }}
                                    </option>
                                </select>
                            </ts-loading-banner>
                            <div
                                class="invalid-feedback"
                                v-if="errors.has('grt_commune_code')"
                            >
                                {{ errors.first("grt_commune_code") }}
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-md-4">
                            {{ $t("employee.village") }}
                        </label>
                        <div class="col-md-8">
                            <ts-loading-banner :loading="grt_commune_change">
                                <div class="input-group">
                                    <select
                                        v-model="model.grt_village_code"
                                        class="form-control"
                                        :class="{
                                            'is-invalid': errors.has(
                                                'grt_village_code'
                                            )
                                        }"
                                    >
                                        <option
                                            :value="null"
                                            disabled
                                            selected
                                            style="display: none;"
                                            >{{ $t("select") }}</option
                                        >
                                        <option
                                            v-for="(village,
                                            index) in grt_villages"
                                            :key="index"
                                            :value="village.village_code"
                                        >
                                            {{ village.name_en }} |
                                            {{ village.name_kh }}
                                        </option>
                                    </select>
                                    <Poptip
                                        :title="$t('employee.village')"
                                        :transfer="true"
                                        width="240"
                                        @on-popper-show="
                                            () => (name_en = name_kh = '')
                                        "
                                        v-if="
                                            !villageSaving && model.commune_code
                                        "
                                    >
                                        <a
                                            class="btn btn-info"
                                            v-tooltip="$t('add')"
                                            :disabled="villageSaving"
                                        >
                                            <i
                                                class="fas fa-circle-notch fa-spin"
                                                v-if="villageSaving"
                                            ></i>
                                            <i class="fas fa-plus" v-else></i>
                                        </a>
                                        <div slot="content">
                                            <div class="mb-2">
                                                <label class="required">{{
                                                    $t("employee.nameEn")
                                                }}</label>
                                                <input
                                                    v-model.trim="name_en"
                                                    type="text"
                                                    class="form-control"
                                                    :class="{
                                                        'is-invalid': errors.has(
                                                            'name_en'
                                                        )
                                                    }"
                                                />
                                                <div
                                                    class="invalid-feedback"
                                                    v-if="errors.has('name_en')"
                                                >
                                                    {{
                                                        errors.first("name_en")
                                                    }}
                                                </div>
                                            </div>
                                            <div class="mb-2">
                                                <label class="required">{{
                                                    $t("employee.nameKh")
                                                }}</label>
                                                <input
                                                    v-model.trim="name_kh"
                                                    type="text"
                                                    class="form-control"
                                                    :class="{
                                                        'is-invalid': errors.has(
                                                            'name_kh'
                                                        )
                                                    }"
                                                />
                                                <div
                                                    class="invalid-feedback"
                                                    v-if="errors.has('name_kh')"
                                                >
                                                    {{
                                                        errors.first("name_kh")
                                                    }}
                                                </div>
                                            </div>
                                            <div class="tw-mt-2 tw-text-right">
                                                <a
                                                    class="ivu-btn ivu-btn-primary ivu-btn-small"
                                                    @click.prevent="
                                                        onSaveVillage
                                                    "
                                                >
                                                    <span>Save</span>
                                                </a>
                                            </div>
                                        </div>
                                    </Poptip>
                                    <a
                                        class="btn btn-default"
                                        v-tooltip="$t('add')"
                                        :disabled="!model.commune_code"
                                        v-else
                                    >
                                        <i
                                            class="fas fa-circle-notch fa-spin"
                                            v-if="villageSaving"
                                        ></i>
                                        <i class="fas fa-plus" v-else></i>
                                    </a>
                                </div>
                            </ts-loading-banner>
                            <div
                                class="invalid-feedback"
                                v-if="errors.has('grt_village_code')"
                            >
                                {{ errors.first("grt_village_code") }}
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-md-4">
                            {{ $t("employee.houseNo") }}
                        </label>
                        <div class="col-md-8">
                            <input
                                v-model.trim="model.grt_house_no"
                                type="text"
                                class="form-control"
                                :class="{
                                    'is-invalid': errors.has('grt_house_no')
                                }"
                            />
                            <div
                                class="invalid-feedback"
                                v-if="errors.has('grt_house_no')"
                            >
                                {{ errors.first("grt_house_no") }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tw-flex tw-justify-end tw-space-x-2 tw-sh">
                <ts-button
                    @click.prevent="() => $emit('cancel')"
                    class="btn-gray"
                >
                    {{ $t("cancel") }}</ts-button
                >
                <ts-button
                    color="info"
                    outline
                    :waiting="save_previewing"
                    :disabled="save_previewing || waiting"
                    @click.prevent="onSavePreview"
                >
                    {{ $t("employee.savePreviewContract") }}</ts-button
                >
                <ts-button
                    color="primary"
                    @click.prevent="onSave"
                    :waiting="waiting"
                    :disabled="waiting || save_previewing"
                    class="btn btn-primary d-block"
                >
                    {{ $t("save") }}</ts-button
                >
            </div>
            <Spin size="large" fix v-if="loading"> </Spin>
        </form>
        <Modal
            v-model="show"
            draggable
            sticky
            scrollable
            :mask="false"
            :footer-hide="true"
            fullscreen
            :z-index="1022"
            :title="$t('previewPdf')"
        >
            <div class="demo-spin-article">
                <div id="container">
                    <ts-preview-pdf :src="src" />
                </div>
            </div>
            <Spin size="large" fix v-if="save_previewing"> </Spin>
        </Modal>
    </div>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapActions, mapState } from "vuex";
import { required } from "vuelidate/lib/validators";
import { isEmpty } from "lodash";

export default {
    name: "addContractInfo",
    props: ["employees"],
    data() {
        return {
            errors: new Errors(),
            loading: false,
            waiting: false,
            save_previewing: false,
            show: false,
            model: {
                employee_id: null,
                village_code: null,
                commune_code: null,
                district_code: null,
                province_code: null,
                level_id: null,
                salary_level_id: null,
                age: null,
                employer_name: null,
                guarantor_name: null,
                guarantor_sex: null,
                guarantor_age: null,
                nationality_id: null,
                guarantor_nid_number: null,
                spouse_name: null,
                spouse_sex: null,
                spouse_age: null,
                spouse_nid_number: null,
                relationship: null,
                grt_village_code: null,
                grt_commune_code: null,
                grt_district_code: null,
                grt_province_code: null,
                grt_house_no: null
            },
            province_change: false,
            district_change: false,
            commune_change: false,
            districts: [],
            communes: [],
            villages: [],
            grt_province_change: false,
            grt_district_change: false,
            grt_commune_change: false,
            grt_districts: [],
            grt_communes: [],
            grt_villages: [],
            villageSaving: false,
            name_en: null,
            name_kh: null,
            marritalStatus: [
                "Single|នៅលីវ",
                "Married|រៀបការ",
                "Widow|មេម៉ាយ/ពោះម៉ាយ"
            ],
            src: ''
        };
    },
    computed: {
        ...mapState("humanResource/employee", [
            "provinces",
            "levels",
            "salary_levels",
            "nationalities",
            "edit_data"
        ]),
        salaryLevels() {
            if (this.model.level_id) {
                return this.salary_levels.filter(
                    e => e.level_id == this.model.level_id
                );
            }
            return this.salary_levels;
        }
    },
    validations: {
        name_en: { required },
        name_kh: { required },
        villageForm: ["name_en", "name_kh"]
    },
    methods: {
        ...mapActions("humanResource/employee", [
            "getNationality",
            "getLevel",
            "getProvince",
            "getDistrict",
            "getCommune",
            "getVillage"
        ]),
        photo(record) {
            if (record.photo) {
                return record.photo;
            }

            return record.sex == "Male"
                ? require("@/assets/staff-default-man.png")
                : require("@/assets/staff-default-women.png");
        },
        async fetchResource() {
            this.errors = new Errors();
            this.loading = true;
            this.clear();
            await this.getNationality();
            await this.getLevel();
            await this.getProvince();
            this.loading = false;
        },
        onSave() {
            this.errors = new Errors();
            this.waiting = true;
            this.$store
                .dispatch(
                    "humanResource/employee/storeContract",
                    Object.assign({}, this.model, {
                        is_save_preview: false
                    })
                )
                .then(response => {
                    this.notice({
                        type: "success",
                        text: response.message
                    });
                    this.$emit("cancel");
                    this.$emit("fetchData");
                    this.clear();
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.waiting = false;
                });
        },
        onSavePreview() {
            this.errors = new Errors();
            this.save_previewing = true;
            this.$store
                .dispatch(
                    "humanResource/employee/storeContract",
                    Object.assign({}, this.model, {
                        is_save_preview: true
                    })
                )
                .then(response => {
                    this.show = true
                    this.$emit("cancel");
                    this.$emit("fetchData");
                    this.clear();
                    this.src = response.url
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.save_previewing = false;
                });
        },
        async getProvince() {
            this.loading = true;
            await this.$store
                .dispatch("humanResource/employee/getProvince")
                .then(() => {
                    this.setEditData();
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.notice({ type: "error", text: error.message });
                });
        },
        provinceChange(province_code) {
            this.province_change = true;
            this.getDistrict(province_code)
                .then(response => {
                    this.districts = response.data;
                })
                .catch(error => {
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.province_change = false;
                });
        },

        districtChange(district_code) {
            this.district_change = true;
            this.getCommune(district_code)
                .then(response => {
                    this.communes = response.data;
                })
                .catch(error => {
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.district_change = false;
                });
        },

        communeChange(commune_code) {
            this.commune_change = true;
            this.getVillage(commune_code)
                .then(response => {
                    this.villages = response.data;
                })
                .catch(error => {
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.commune_change = false;
                });
        },
        grtProvinceChange(province_code) {
            this.grt_province_change = true;
            this.getDistrict(province_code)
                .then(response => {
                    this.grt_districts = response.data;
                })
                .catch(error => {
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.grt_province_change = false;
                });
        },

        grtDistrictChange(district_code) {
            this.grt_district_change = true;
            this.getCommune(district_code)
                .then(response => {
                    this.grt_communes = response.data;
                })
                .catch(error => {
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.grt_district_change = false;
                });
        },

        grtCommuneChange(commune_code) {
            this.grt_commune_change = true;
            this.getVillage(commune_code)
                .then(response => {
                    this.grt_villages = response.data;
                })
                .catch(error => {
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.grt_commune_change = false;
                });
        },
        async onSaveVillage() {
            this.$v.villageForm.$touch();
            if (this.$v.villageForm.$invalid) return;

            this.villageSaving = true;
            this.$store
                .dispatch("humanResource/employee/addVillage", {
                    name_en: this.name_en,
                    name_kh: this.name_kh,
                    commune_code: this.model.commune_code
                })
                .then(response => {
                    this.villages.push({
                        name_en: response.resource.name_en,
                        name_kh: response.resource.name_kh,
                        village_code: response.resource.village_code
                    });
                    this.model.village_code = response.resource.village_code;
                })
                .catch(error => {
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.villageSaving = false;
                    this.name_en = "";
                    this.name_kh = "";
                });
        },
        setEditData() {
            if (!isEmpty(this.edit_data)) {
                if (this.edit_data.province_code) {
                    this.provinceChange(this.edit_data.province_code);
                }
                if (this.edit_data.district_code) {
                    this.districtChange(this.edit_data.district_code);
                }
                if (this.edit_data.commune_code) {
                    this.communeChange(this.edit_data.commune_code);
                }
                this.model.province_code = this.edit_data.province_code;
                this.model.district_code = this.edit_data.district_code;
                this.model.commune_code = this.edit_data.commune_code;
                this.model.village_code = this.edit_data.village_code;
                this.model.level_id = this.edit_data.level_id;
                this.model.salary_level_id = this.edit_data.salary_level_id;
                this.model.age = this.edit_data.age;
                this.model.marrital_status = this.edit_data.marrital_status;
                this.model.employer_name = this.edit_data.employer_name;
                this.model.employee_id = this.edit_data.employee_id;

                if (!isEmpty(this.edit_data.guarantor)) {
                    if (this.edit_data.guarantor.grt_province_code) {
                        this.grtProvinceChange(
                            this.edit_data.guarantor.grt_province_code
                        );
                    }
                    if (this.edit_data.guarantor.grt_district_code) {
                        this.grtDistrictChange(
                            this.edit_data.guarantor.grt_district_code
                        );
                    }
                    if (this.edit_data.guarantor.grt_commune_code) {
                        this.grtCommuneChange(
                            this.edit_data.guarantor.grt_commune_code
                        );
                    }
                    this.model.grt_province_code = this.edit_data.guarantor.grt_province_code;
                    this.model.grt_district_code = this.edit_data.guarantor.grt_district_code;
                    this.model.grt_commune_code = this.edit_data.guarantor.grt_commune_code;
                    this.model.grt_village_code = this.edit_data.guarantor.grt_village_code;
                    this.model.guarantor_name = this.edit_data.guarantor.guarantor_name;
                    this.model.guarantor_sex = this.edit_data.guarantor.guarantor_sex;
                    this.model.guarantor_age = this.edit_data.guarantor.guarantor_age;
                    this.model.guarantor_nid_number = this.edit_data.guarantor.guarantor_nid_number;
                    this.model.nationality_id = this.edit_data.guarantor.nationality_id;
                    this.model.spouse_nid_number = this.edit_data.guarantor.spouse_nid_number;
                    this.model.spouse_name = this.edit_data.guarantor.spouse_name;
                    this.model.spouse_age = this.edit_data.guarantor.spouse_age;
                    this.model.spouse_sex = this.edit_data.guarantor.spouse_sex;
                    this.model.relationship = this.edit_data.guarantor.relationship;
                    this.model.grt_house_no = this.edit_data.guarantor.grt_house_no;
                }
            }
        },
        clear() {
            this.model = {
                employee_id: null,
                village_code: null,
                commune_code: null,
                district_code: null,
                province_code: null,
                level_id: null,
                salary_level_id: null,
                age: null,
                employer_name: null,
                guarantor_name: null,
                guarantor_sex: null,
                guarantor_age: null,
                nationality_id: null,
                guarantor_nid_number: null,
                spouse_name: null,
                spouse_sex: null,
                spouse_age: null,
                spouse_nid_number: null,
                relationship: null,
                grt_village_code: null,
                grt_commune_code: null,
                grt_district_code: null,
                grt_province_code: null,
                grt_house_no: null
            };
        },
        notice(not) {
            this.$Notice[not.type]({
                title: "EMPLOYEE",
                desc: not.text
            });
        }
    }
};
</script>
<style scoped>
.section-divider {
    border-bottom: 1px solid #eee;
    margin-bottom: 10px;
}
</style>